import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import Shops from "./Shops";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";


function ShopsPage(){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageShops')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('manageShops')}</Title>
                    <Shops/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(ShopsPage);
